'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierReadyToSignModal', cobCarrierReadyToSignModal);

	cobCarrierReadyToSignModal.$inject = [
		'sessionService', '$state', 'subjectObserverMessagesService', 'observerService'
	];

	var sessionService,
		$location,
		$state,
		subjectObserverMessagesService,
		observerService,
		subjectMessages,
		observerMessages;

	function
	cobCarrierReadyToSignModal(_sessionService_, _$state_, _subjectObserverMessagesService_, _observerService_) {
		sessionService = _sessionService_;
		$state = _$state_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/readyToSignModal.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {

			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {
				hidden: true
			};
			var broker = sessionService.getBrokerBranding();
			if (broker) {
				scope.m.logoUrl = sessionService.getBrokerLogoURL();
				scope.m.welcomeMessage = broker.welcomeMessage;
				scope.m.brokerName = broker.brokerName;
			}

			scope.hide = hide;
			scope.navTo = navTo;
			registerObserverHandlers();
		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_READY_TO_SIGN, handler: show }
				]);
		}

		function show() {
			scope.m.hidden = false;
		}

		function hide() {
			scope.m.hidden = true;
		}

		function navTo(view) {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				view);
			hide();
		}
	}

})();
